import { QuoteLineItemProps } from '@partsbadger/types';

/**
 * Whether the material, finish and coating suggestions of a part are still loading: its 2D
 * analysis (conversion and preview, by pb-api) has not completed, or the Drawing File Analyzer,
 * which runs on its own and usually ends later, has not answered. The server keeps that state, so
 * it survives a page reload; it expires on its own if the analyzer never answers.
 */
export const areDrawingSuggestionsLoading = (product?: QuoteLineItemProps['product'] | null): boolean => {
    const file2d = product?.analysis_status?.file_2d;
    if (!product?.has_file_2d || !file2d) return false;
    return file2d.completed === false || Boolean(file2d.suggestions_pending);
};
